import React, { RefObject, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import stylesPc from "./VideoPlayer.module.css";
import stylesSp from "./VideoPlayer_SP.module.css";
import styleIpad from "./VideoPlayer_IP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import CaptionsPanel from "./captions/CaptionsPanel";
import { Video } from "../../../../common/video/models/Video";
import EditAndUploadToHubModal from "../../../../components/widgets/EditAndUploadToHubModal";
import { AppState } from "../../../../root/RootReducer";
import { isAdmin, isEditor } from "../../../../utils/LogicUtils";
import { useInitText } from "../../../../components/function/useInitText";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import { MoreVert } from "@material-ui/icons";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { createStyles, makeStyles } from "@material-ui/core";
import { t } from "i18next";
const MODAL_WIDTH = 236;

interface VideoPageLiveAreaProps {
    video: Video;
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    setEditModalOpen: (target: boolean) => void;
    setMsg: (msg: string) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        menuItemText: {
            width: "178px",
            height: "32px",
            paddingTop: "4px",
            paddingLeft: "20px",
            backgroundColor: "#1E2329",
            "&:hover": {
                backgroundColor: "#35393F",
            },
        },
    })
);

function VideoPlayer({
    video,
    videoRef,
    currentVideoTimeMs,
    setEditModalOpen,
    setMsg,
}: VideoPageLiveAreaProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : IsDevice("ipad") ? styleIpad : stylesSp;

    const classes = useStyles();

    // ユーザー取得
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    // 動画再生するURL
    const [currentUrl, setCurrentUrl] = useInitText();
    const [isShowMore, setIsShowMore] = useState<boolean>(false);

    const videoDownloadControl = document.getElementById("videoPlayer");

    const modalLeft = useMemo(() => {
        if (isShowMore) {
            const element = document.getElementById("videoPlayer");
            if (element) {
                return `${element.getBoundingClientRect().right - MODAL_WIDTH}px`;
            }
        }
    }, [isShowMore]);

    if (videoDownloadControl) {
        videoDownloadControl.oncontextmenu = function () {
            return false;
        };
    }

    // 動画ファイルのダウンロード
    const handleDownloadVideo = () => {
        const alink = document.createElement("a");
        alink.href = video.downloadUrl;
        alink.click();
    };

    useEffect(() => {
        if (currentUrl === "") {
            setCurrentUrl(video.playUrl);
        }
        // eslint-disable-next-line
    }, [video.playUrl]);

    if (!video) {
        return <div>Loading...</div>;
    }

    return (
        <div className={styles.videoArea}>
            <div className={styles.videoAndReactions}>
                <video
                    id="videoPlayer"
                    className={
                        videoRef.current &&
                        videoRef.current.videoWidth / videoRef.current.videoHeight >= 1
                            ? styles.LandscapeVideo
                            : styles.PortraitVideo
                    }
                    controls
                    autoPlay
                    width="100%"
                    ref={videoRef}
                    key={currentUrl} // Needed to inform React of source changes.
                    controlsList="nodownload"
                >
                    <source src={currentUrl} type="video/mp4" />
                    <track default={false} kind="subtitles" srcLang="ja" label="オン" />
                </video>

                {/*                 <VideoReactions
                    reactions={video.reactions}
                    videoId={video.id}
                    videoDuration={video.durationMillis}
                    videoRef={videoRef}
                /> */}
            </div>
            {IsDevice("desktop") && (
                <div
                    className={`${styles.caption} ${
                        isAdmin(user?.roles) || isEditor(user?.roles) ? styles.isAdmin : ""
                    }`}
                >
                    <CaptionsPanel
                        video={video}
                        captions={video.captions}
                        videoRef={videoRef}
                        currentVideoTimeMs={currentVideoTimeMs}
                        setEditModalOpen={setEditModalOpen}
                    />
                </div>
            )}
            {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                <div
                    onClick={() => setIsShowMore(!isShowMore)}
                    className={styles.moreIcon}
                    id="moreIcon"
                >
                    <MoreVert />
                </div>
            )}
            {(isAdmin(user?.roles) || isEditor(user?.roles)) && isShowMore && (
                <div
                    className={styles.menuItem}
                    style={{ left: IsDevice("desktop") ? modalLeft : "" }}
                >
                    <div>
                        <EditAndUploadToHubModal video={video} showModal={setEditModalOpen} />
                    </div>
                    <div>
                        <VideoMenu
                            video={video}
                            videoId={video.id ? video.id : 0}
                            setMsg={setMsg}
                        />
                    </div>
                    <div className={classes.menuItemText} onClick={handleDownloadVideo}>
                        <PuiTypography size={14}>{t("ダウンロード")}</PuiTypography>
                    </div>
                </div>
            )}
        </div>
    );
}

export default VideoPlayer;
